module.exports = __webpack_public_path__ + "s4.no1.7a260196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s4.no1.jpg
// module id = mZhZ
// module chunks = 0